/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, number as codecNumber, oneOf as codecOneOf } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
import { CoursePermission } from './CoursePermission';
import { GlobalPermission } from './GlobalPermission';
const PermissionExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'missingPermissions',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecOneOf([GlobalPermission, CoursePermission]))),
        'missing_permissions',
    ],
    ['userId', /* #__PURE__ */ parsers.maybeNull(codecNumber), 'user_id'],
]), BaseError);
export class PermissionException extends BaseError {
    static decode(input) {
        return PermissionExceptionParser.decode(input).map(res => new PermissionException(res));
    }
    static unsafeDecode(input) {
        return PermissionException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PermissionExceptionParser.encode(data);
    }
    static schema() {
        return PermissionExceptionParser.schema();
    }
}
